/*
 * Public API Surface of google
 */

export * from './lib/google-maps-api-wrapper';
export * from './lib/managers/marker.manager';
export * from './lib/managers/circle.manager';
export * from './lib/managers/polygon.manager';
export * from './lib/managers/polyline.manager';
export * from './lib/managers/rectangle.manager';
export * from './lib/managers/info-window.manager';
export * from './lib/google.component';
export * from './lib/google.module';
export * from './lib/options';
export { isValidMarkerIcon } from './lib/util/is-valid-marker-icon';
